// frontend/src/pages/DashboardPage.js
import React, { useState, useEffect, useCallback } from 'react'; // Removido useMemo
import api from '../services/api';
import { ArrowPathIcon, PhotoIcon } from '@heroicons/react/24/outline'; // Adicionado PhotoIcon
import { ClockIcon } from '@heroicons/react/24/outline'; // Ou ExclamationTriangleIcon
import { ArrowDownOnSquareIcon } from '@heroicons/react/24/outline'; // Adiciona ícone de exportação
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const BACKEND_URL = api.defaults.baseURL.replace('/api', ''); // Para imagens (ajustado)

const DashboardPage = () => {
    // Estados de Dados e UI
    const [orderItems, setOrderItems] = useState([]);
    const [isLoading, setIsLoading] = useState(true); // Inicia true para buscar na montagem
    const [error, setError] = useState('');
    const [isExporting, setIsExporting] = useState(false);
    const [exportStartDate, setExportStartDate] = useState(null);
    const [exportEndDate, setExportEndDate] = useState(null);
    const [exportType, setExportType] = useState('all');

    // Estados de Controle
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [limit] = useState(50);
    const [statusFilter, setStatusFilter] = useState('');
    const [logisticsFilter, setLogisticsFilter] = useState(''); // Filtro de logística
    const [searchTerm, setSearchTerm] = useState(''); // Para o input
    const [submittedSearchTerm, setSubmittedSearchTerm] = useState(''); // Para a busca efetiva
    const [sortBy, setSortBy] = useState('orderDate');
    const [sortOrder, setSortOrder] = useState('DESC');

    // Estados de Sincronização
    const [isSyncing, setIsSyncing] = useState(false);
    const [syncStatus, setSyncStatus] = useState({ message: '', type: '', details: null });

    // Estados de Sincronização de Rastreamento
    const [isSyncingTracking, setIsSyncingTracking] = useState(false);
    const [trackingSyncStatus, setTrackingSyncStatus] = useState({ message: '', type: '' });

    // Estados de Importação Manual
    const [isImporting, setIsImporting] = useState(false);
    const [importStartOrder, setImportStartOrder] = useState('');
    const [importEndOrder, setImportEndOrder] = useState('');
    const [importStatus, setImportStatus] = useState({ message: '', type: '' });

    // // --- 1. ADICIONAR ESTADOS PARA NOVOS FILTROS ---
    // const [filterReady, setFilterReady] = useState(false);       // Filtro para isReadyToShip
    // const [filterProcessed, setFilterProcessed] = useState(false); // Filtro para isProcessedBySupplier

    // --- Função para Buscar Dados da API ---
    // Nota: Removido useCallback aqui, pois a função será definida dentro do useEffect
    // ou chamada diretamente pelos handlers que já usam useCallback ou são simples.
    // Manteremos separada por organização, mas o useEffect principal controlará a chamada.
    const runFetchOrderItems = async (pageToFetch) => {
        setIsLoading(true);
        setError('');
        console.log(`==> runFetchOrderItems chamada com: page=${pageToFetch}, limit=${limit}, status=${statusFilter}, logistics=${logisticsFilter}, search=${submittedSearchTerm}, sortBy=${sortBy}, sortOrder=${sortOrder}`);

        try {
            const params = new URLSearchParams({
                page: pageToFetch, limit: limit, sortBy: sortBy, sortOrder: sortOrder,
            });
            if (statusFilter) params.append('status', statusFilter);
            if (logisticsFilter) params.append('logistics', logisticsFilter);
            if (submittedSearchTerm) params.append('search', submittedSearchTerm); // Usa o termo submetido
            // <<< Adiciona novos params booleanos SÓ SE TRUE >>>
            // if (filterReady) params.append('is_ready', 'true');
            // if (filterProcessed) params.append('is_processed', 'true');

            console.log(`==> Chamando API: /orders/items?${params.toString()}`);
            const response = await api.get(`/orders/items?${params.toString()}`);

            setOrderItems(response.data.items || []);
            setTotalPages(response.data.totalPages || 1);
            setTotalItems(response.data.totalItems || 0);
            // Define a página atual baseada na resposta da API
            setCurrentPage(response.data.currentPage || 1);

        } catch (err) {
            console.error("Erro ao buscar itens de pedido:", err);
            setError(err.response?.data?.message || 'Falha ao carregar pedidos.');
            setOrderItems([]); setTotalPages(1); setTotalItems(0);
        } finally {
            setIsLoading(false);
        }
    };

    // --- Efeito Principal para Buscar Dados ---
    // Dispara a busca quando a PÁGINA ou os FILTROS/ORDENAÇÃO EFETIVOS mudam
    useEffect(() => {
        console.log('==> useEffect [currentPage, statusFilter, logisticsFilter, submittedSearchTerm, sortBy, sortOrder] disparado.');
        runFetchOrderItems(currentPage); // Chama a função de busca com a página atual
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage, statusFilter, logisticsFilter, submittedSearchTerm, sortBy, sortOrder, limit]); // Adiciona limit como dependencia por segurança, remove runFetchOrderItems

    // --- Função de Sincronização ---
    const handleSyncOrders = useCallback(async () => {
        setIsSyncing(true);
        setSyncStatus({ message: 'Iniciando sincronização...', type: 'info' });
        setError('');

        try {
            // 1. Dispara o sync (retorna imediatamente com jobId)
            const response = await api.post('/orders/sync');
            const jobId = response.data.jobId;

            if (!jobId) {
                throw new Error('Servidor não retornou um jobId.');
            }

            setSyncStatus({ message: 'Sincronizando pedidos com a Shopify...', type: 'info' });

            // 2. Faz polling a cada 3 segundos até o job terminar
            const pollInterval = setInterval(async () => {
                try {
                    const statusRes = await api.get(`/orders/sync/status/${jobId}`);
                    const job = statusRes.data;

                    if (job.status === 'processing') {
                        setSyncStatus({ message: job.progress || 'Processando...', type: 'info' });
                        return; // Continua polling
                    }

                    // Job terminou (completed ou failed) - para o polling
                    clearInterval(pollInterval);
                    setIsSyncing(false);

                    if (job.status === 'completed') {
                        const hasErrors = job.result?.details?.errors?.length > 0;
                        setSyncStatus({
                            message: job.result?.message || 'Sincronização concluída.',
                            type: hasErrors ? 'warning' : 'success',
                            details: job.result?.details
                        });
                        // Recarrega a lista de pedidos
                        if (currentPage !== 1) {
                            setCurrentPage(1);
                        } else {
                            runFetchOrderItems(1);
                        }
                    } else {
                        // failed
                        setSyncStatus({
                            message: job.result?.message || 'Falha na sincronização.',
                            type: 'error',
                            details: job.result?.details
                        });
                    }
                } catch (pollError) {
                    console.error('Erro ao verificar status do sync:', pollError);
                    clearInterval(pollInterval);
                    setIsSyncing(false);
                    setSyncStatus({ message: 'Erro ao verificar status da sincronização.', type: 'error' });
                }
            }, 3000); // Verifica a cada 3 segundos

        } catch (err) {
            setSyncStatus({ message: err.response?.data?.message || 'Falha ao iniciar sync.', type: 'error' });
            setIsSyncing(false);
        }
    }, [currentPage]);

    // --- Função de Sincronização de Rastreamento ---
    const handleSyncTracking = useCallback(async () => {
        setIsSyncingTracking(true); 
        setTrackingSyncStatus({ message: 'Enviando códigos de rastreamento...', type: 'info' }); 
        setError('');
        try {
            const response = await api.post('/orders/sync-tracking');
            const message = response.data.message || 'Sincronização de rastreamento concluída.';
            const type = response.status === 207 || response.data.errors?.length > 0 ? 'warning' : 'success';
            setTrackingSyncStatus({ message: message, type: type });
            // Atualiza a lista após sincronizar
            runFetchOrderItems(currentPage);
        } catch (err) {
            setTrackingSyncStatus({ 
                message: err.response?.data?.message || 'Falha ao sincronizar rastreamento.', 
                type: 'error' 
            });
        } finally { 
            setIsSyncingTracking(false); 
        }
    }, [currentPage]);

    // --- Função de Importação Manual ---
    const handleImportRange = async () => {
        if (!importStartOrder || !importEndOrder) {
            setImportStatus({ message: 'Informe os números inicial e final.', type: 'error' });
            return;
        }

        const start = parseInt(importStartOrder, 10);
        const end = parseInt(importEndOrder, 10);

        if (isNaN(start) || isNaN(end) || start > end) {
            setImportStatus({ message: 'Números de pedido inválidos.', type: 'error' });
            return;
        }

        setIsImporting(true);
        setImportStatus({ message: 'Importando...', type: 'info' });

        try {
            const response = await api.post('/orders/import-range', {
                startOrderNumber: start,
                endOrderNumber: end
            });

            const message = `✓ ${response.data.imported} pedido(s) importado(s). ${response.data.skipped} já existia(m).`;
            const type = response.data.errors.length > 0 ? 'warning' : 'success';
            
            setImportStatus({ message: message, type: type });
            
            // Limpa os inputs
            setImportStartOrder('');
            setImportEndOrder('');
            
            // Recarrega a lista
            runFetchOrderItems(currentPage);

        } catch (err) {
            console.error("Erro ao importar pedidos:", err);
            setImportStatus({ 
                message: err.response?.data?.message || 'Erro ao importar pedidos.', 
                type: 'error' 
            });
        } finally {
            setIsImporting(false);
        }
    };

    // --- Handlers de Controle ---
    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages && newPage !== currentPage) {
            setCurrentPage(newPage); // Apenas muda o estado, useEffect reage
        } // Não precisa de else if aqui, pois o estado não será setado se inválido
    };

    const handleFilterChange = (event) => {
        const newStatus = event.target.value;
        setStatusFilter(newStatus); // Muda estado
        setCurrentPage(1);          // Muda estado, useEffect reage a ambos
    };

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value); // Apenas atualiza o input
    };

    const handleSearchSubmit = (event) => {
        event.preventDefault();
        const trimmedSearch = searchTerm.trim();
        console.log('==> handleSearchSubmit. Termo Efetivo:', trimmedSearch);
        setSubmittedSearchTerm(trimmedSearch); // Define o termo que dispara a busca
        setCurrentPage(1);                     // Reseta página, useEffect reage a ambos
    };

     const handleSort = (field) => {
        const newSortOrder = sortBy === field && sortOrder === 'ASC' ? 'DESC' : 'ASC';
        setSortBy(field);
        setSortOrder(newSortOrder);
        setCurrentPage(1); // Reseta página, useEffect reage
     };

     // --- NOVA FUNÇÃO PARA EXPORTAR CSV ---
    const handleExportCSV = async () => {
        setIsExporting(true); // Ativa o loading
        console.log('Iniciando exportação para CSV com os filtros atuais...');

        try {
            if (!exportStartDate || !exportEndDate) {
                setError('Por favor, selecione uma data de início e uma data de fim para exportar.');
                return;
            }
            const params = new URLSearchParams();
            if (statusFilter) params.append('status', statusFilter);
            if (submittedSearchTerm) params.append('search', submittedSearchTerm);

            params.append('startDate', exportStartDate.toISOString().split('T')[0]);
            params.append('endDate', exportEndDate.toISOString().split('T')[0]);
            params.append('exportType', exportType);

            // Chama a nova API de exportação
            const response = await api.get(`/orders/export?${params.toString()}`, {
                responseType: 'blob', // Importante: diz ao Axios para esperar um arquivo/blob
            });

            // Cria um link temporário para iniciar o download
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            const fileName = `pedidos_${exportStartDate.toISOString().split('T')[0]}_a_${exportEndDate.toISOString().split('T')[0]}.csv`; // Nome do arquivo com data
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();

            // Limpa o link
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (err) {
            console.error("Erro ao exportar CSV:", err);
            // Como a resposta de erro pode ser um blob, precisamos lê-lo como texto
            if (err.response && err.response.data instanceof Blob) {
                const errorText = await err.response.data.text();
                const errorJson = JSON.parse(errorText);
                setError(errorJson.message || 'Falha ao exportar CSV.');
            } else {
                setError(err.response?.data?.message || 'Falha ao exportar CSV.');
            }
        } finally {
            setIsExporting(false); // Desativa o loading
        }
    };

    // Dentro de DashboardPage.js
const handleUpdateItem = async (lineItemId, field, value) => {
    // <<< LOG INICIAL >>>
    console.log(`--> handleUpdateItem CHAMADO para Item ID: ${lineItemId}, Campo: ${field}, Valor:`, value, `(Tipo: ${typeof value})`);
    // --------------------

    const originalItem = orderItems.find(item => item.lineItemId === lineItemId);
    try {
        const payload = { [field]: value };
        console.log(`--> Enviando PAYLOAD para API:`, payload); // Log do payload
        const response = await api.put(`/orders/items/${lineItemId}`, payload);
        console.log(`<-- Resposta da API recebida:`, response.data); // Log da resposta

        // --- DEBUG: Log antes de atualizar estado ---
         console.log(`--> Atualizando estado local para item ${lineItemId}. Objeto da resposta:`, response.data.item);
         // -----------------------------------------

        setOrderItems(prev => {
            const newState = prev.map(item =>
                item.lineItemId === lineItemId ? response.data.item : item
            );
             // --- DEBUG: Log após calcular novo estado ---
            // console.log("--> Novo estado calculado:", newState.find(i => i.lineItemId === lineItemId)); // Loga o item atualizado no novo estado
             // -----------------------------------------
            return newState;
        });

        if (error) setError('');
    } catch (err) {
         console.error(`Erro DENTRO de handleUpdateItem para item ${lineItemId}:`, err); // Log mais específico
         setError(`Erro ao salvar item ${lineItemId}: ${err.response?.data?.message || 'Erro desconhecido'}`);
    }
};

    // --- JSX (Completo e usando os handlers/estados corretos) ---
    return (
        <div className="p-4 md:p-6 lg:p-8">
            {/* Título e Botões Sync */}
             <div className="flex flex-wrap justify-between items-center mb-4 gap-4">
                <h1 className="text-2xl font-semibold text-gray-800">Dashboard de Pedidos</h1>
                <div className="flex gap-3">
                    <button onClick={handleSyncOrders} disabled={isSyncing || isLoading} className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 disabled:opacity-50 disabled:cursor-not-allowed">
                        <ArrowPathIcon className={`h-5 w-5 mr-2 ${isSyncing ? 'animate-spin' : ''}`} />
                        {isSyncing ? 'Sincronizando...' : 'Sincronizar Pedidos'}
                    </button>
                    <button onClick={handleSyncTracking} disabled={isSyncingTracking || isLoading} className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed">
                        <ArrowPathIcon className={`h-5 w-5 mr-2 ${isSyncingTracking ? 'animate-spin' : ''}`} />
                        {isSyncingTracking ? 'Enviando...' : 'Sincronizar Rastreamento'}
                    </button>
                </div>
                {/* <button
                         onClick={handleExportCSV}
                         disabled={isExporting || isLoading}
                         className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed"
                     >
                         <ArrowDownOnSquareIcon className={`h-5 w-5 mr-2 ${isExporting ? 'animate-spin' : ''}`} />
                         {isExporting ? 'Exportando...' : 'Exportar CSV'}
                     </button> */}
             </div>
             {/* Status Sync */}
             {syncStatus.message && ( <div className={`mb-4 p-3 rounded-md text-sm ${ syncStatus.type === 'success' ? 'bg-green-100 text-green-800 border border-green-300' : syncStatus.type === 'warning' ? 'bg-yellow-100 text-yellow-800 border border-yellow-300' : syncStatus.type === 'error' ? 'bg-red-100 text-red-800 border border-red-300' : 'bg-blue-100 text-blue-800 border border-blue-300' }`}> <p className='font-medium'>{syncStatus.message}</p> {syncStatus.details?.errors?.length > 0 && ( <ul className="mt-2 list-disc list-inside text-xs"> {syncStatus.details.errors.map((errMsg, index) => ( <li key={index}>{errMsg}</li> ))} </ul> )} </div> )}
             
             {/* Status Tracking Sync */}
             {trackingSyncStatus.message && ( <div className={`mb-4 p-3 rounded-md text-sm ${ trackingSyncStatus.type === 'success' ? 'bg-green-100 text-green-800 border border-green-300' : trackingSyncStatus.type === 'warning' ? 'bg-yellow-100 text-yellow-800 border border-yellow-300' : trackingSyncStatus.type === 'error' ? 'bg-red-100 text-red-800 border border-red-300' : 'bg-blue-100 text-blue-800 border border-blue-300' }`}> <p className='font-medium'>{trackingSyncStatus.message}</p> </div> )}

             {/* Importação Manual de Pedidos */}
             <div className="mb-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
                <h3 className="text-sm font-semibold text-blue-900 mb-2">⚠️ Importar Pedidos Específicos</h3>
                <p className="text-xs text-blue-700 mb-3">Use esta ferramenta para importar pedidos <strong>PAGOS</strong> que não foram sincronizados automaticamente (ex: pedidos antigos ou fora do limite de 30 dias).</p>
                <div className="flex flex-wrap items-end gap-2">
                    <div>
                        <label className="block text-xs font-medium text-blue-900 mb-1">Pedido Inicial</label>
                        <input
                            type="number"
                            value={importStartOrder}
                            onChange={(e) => setImportStartOrder(e.target.value)}
                            placeholder="Ex: 13123"
                            className="w-32 px-3 py-2 border border-blue-300 rounded-md text-sm"
                            disabled={isImporting}
                        />
                    </div>
                    <div>
                        <label className="block text-xs font-medium text-blue-900 mb-1">Pedido Final</label>
                        <input
                            type="number"
                            value={importEndOrder}
                            onChange={(e) => setImportEndOrder(e.target.value)}
                            placeholder="Ex: 13141"
                            className="w-32 px-3 py-2 border border-blue-300 rounded-md text-sm"
                            disabled={isImporting}
                        />
                    </div>
                    <button
                        onClick={handleImportRange}
                        disabled={isImporting || !importStartOrder || !importEndOrder}
                        className="px-4 py-2 bg-blue-600 text-white rounded-md text-sm font-medium hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed"
                    >
                        {isImporting ? 'Importando...' : 'Importar Range'}
                    </button>
                </div>
                {importStatus.message && (
                    <div className={`mt-3 p-2 rounded text-xs ${
                        importStatus.type === 'success' ? 'bg-green-100 text-green-800' :
                        importStatus.type === 'error' ? 'bg-red-100 text-red-800' :
                        'bg-blue-100 text-blue-800'
                    }`}>
                        {importStatus.message}
                    </div>
                )}
             </div>
             {/* Filtros e Busca */}
             <div className="mb-4 p-4 bg-white rounded shadow-md">
                 <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                     {/* Filtro Status */}
                     <div>
                         <label htmlFor="statusFilter" className="block text-sm font-medium text-gray-700 mb-1">Filtrar por Status</label>
                         <select id="statusFilter" value={statusFilter} onChange={handleFilterChange} className="block w-full px-3 py-2 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                             <option value="">Todos os Status</option>
                             <option value="Pending">Pendente</option>
                             <option value="Processing">Em Processamento</option>
                             <option value="ReadyToShip_Filter">Pronto p/ Envio</option>
                             <option value="ProcessedBySupplier_Filter">Processado</option>
                             <option value="Shipped">Despachado</option>
                             <option value="National Shipping">Envio Nacional</option>
                         </select>
                     </div>
                     {/* Filtro Logística */}
                     <div>
                         <label htmlFor="logisticsFilter" className="block text-sm font-medium text-gray-700 mb-1">Filtrar por Logística</label>
                         <select 
                             id="logisticsFilter" 
                             value={logisticsFilter} 
                             onChange={(e) => { setLogisticsFilter(e.target.value); setCurrentPage(1); }}
                             className="block w-full px-3 py-2 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                         >
                             <option value="">Todas as Logísticas</option>
                             <option value="4star">4star</option>
                             <option value="sihi">Sihi</option>
                             <option value="national_shipping">Nacional</option>
                             <option value="null">Não definido</option>
                         </select>
                     </div>
                     {/* Busca */}
                     <form onSubmit={handleSearchSubmit} className="md:col-span-2">
                         <label htmlFor="search" className="block text-sm font-medium text-gray-700 mb-1">Buscar (Nº Pedido, Produto, SKU, ID Ali, Rastreio)</label>
                         <div className="flex">
                             <input id="search" type="text" value={searchTerm} onChange={handleSearchChange} placeholder="Digite sua busca..." className="flex-grow block w-full px-3 py-2 border border-gray-300 rounded-l-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"/>
                             <button type="submit" className="inline-flex items-center px-4 py-2 border border-transparent rounded-r-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">Buscar</button>
                         </div>
                     </form>
                 </div>
                 {/* --- Nova Seção para Exportação --- */}
                <div className="mt-4 pt-4 border-t border-gray-200 flex flex-wrap items-end gap-4">
                    <h3 className="w-full text-lg font-medium text-gray-800 mb-1">Exportar Relatório CSV</h3>
                    
                    {/* Seletores de Data e Tipo */}
                    <div className="flex flex-wrap items-end gap-3">
                        <div>
                            <label htmlFor="exportStartDate" className="block text-sm font-medium text-gray-700">Data de Início</label>
                            <DatePicker
                                selected={exportStartDate}
                                onChange={(date) => setExportStartDate(date)}
                                selectsStart
                                startDate={exportStartDate}
                                endDate={exportEndDate}
                                dateFormat="dd/MM/yyyy"
                                className="w-36 px-3 py-2 border border-gray-300 rounded-md shadow-sm text-sm"
                                placeholderText="Selecione a data"
                            />
                        </div>
                        <div>
                            <label htmlFor="exportEndDate" className="block text-sm font-medium text-gray-700">Data de Fim</label>
                            <DatePicker
                                selected={exportEndDate}
                                onChange={(date) => setExportEndDate(date)}
                                selectsEnd
                                startDate={exportStartDate}
                                endDate={exportEndDate}
                                minDate={exportStartDate}
                                dateFormat="dd/MM/yyyy"
                                className="w-36 px-3 py-2 border border-gray-300 rounded-md shadow-sm text-sm"
                                placeholderText="Selecione a data"
                            />
                        </div>
                        <div>
                            <label htmlFor="exportType" className="block text-sm font-medium text-gray-700">Tipo de Exportação</label>
                            <select
                                id="exportType"
                                value={exportType}
                                onChange={(e) => setExportType(e.target.value)}
                                className="w-52 px-3 py-2 border border-gray-300 rounded-md shadow-sm text-sm bg-white"
                            >
                                <option value="all">Todos os pedidos</option>
                                <option value="aliexpress">Somente com ID AliExpress</option>
                                <option value="sihi">Somente SIHI</option>
                                <option value="4star">Somente 4Star</option>
                                <option value="processed">Somente processados (com tracking)</option>
                            </select>
                        </div>
                    </div>

                    {/* Botão de Exportar */}
                    <button
                        onClick={handleExportCSV}
                        disabled={isExporting || isLoading || !exportStartDate || !exportEndDate}
                        className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        <ArrowDownOnSquareIcon className={`h-5 w-5 mr-2 ${isExporting ? 'animate-spin' : ''}`} />
                        {isExporting ? 'Exportando...' : 'Exportar CSV por Período'}
                    </button>
                </div>
                 {/* ------------------------------------ */}
             </div>
             {/* Erro Busca */}
             {error && !isLoading && ( <div className="mb-4 p-4 bg-red-100 text-red-700 border border-red-400 rounded">{error}</div> )}
             {/* Tabela */}
             <div className="bg-white rounded shadow-md overflow-x-auto">
                 {isLoading ? <div className="text-center p-10">Carregando pedidos...</div>
                  : orderItems.length === 0 ? <div className="text-center p-10 text-gray-500">Nenhum pedido encontrado...</div>
                  : ( <table className="min-w-full divide-y divide-gray-200">
                         <thead className="bg-gray-50">
                             <tr>
                                <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer" onClick={() => handleSort('orderNumber')}> Pedido # {sortBy === 'orderNumber' ? (sortOrder === 'ASC' ? ' ▲' : ' ▼') : ''} </th>
                                <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer" onClick={() => handleSort('orderDate')}> Data {sortBy === 'orderDate' ? (sortOrder === 'ASC' ? ' ▲' : ' ▼') : ''} </th>
                                <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Imagem</th>
                                <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer" onClick={() => handleSort('variantTitle')}> Variante {sortBy === 'variantTitle' ? (sortOrder === 'ASC' ? ' ▲' : ' ▼') : ''} </th>
                               <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Custo</th>
                               <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">On Hold</th>
                                <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Rastreio</th>
                                <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Logística</th>
                                <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer" onClick={() => handleSort('status')}> Status {sortBy === 'status' ? (sortOrder === 'ASC' ? ' ▲' : ' ▼') : ''} </th>
                                <th scope="col" className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Envio Nac.</th>
                             </tr>
                        </thead>
                         <tbody className="bg-white divide-y divide-gray-200">
                             {orderItems.map((item) => (
                                // console.log(`Renderizando item ID: ${item.lineItemId}`, item);
                                
                                 <tr key={item.lineItemId}>
                                    <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900 flex items-center space-x-1">
                     <span>#{item.shopifyOrderId}</span>
                     {/* <<< INDICADOR VISUAL CONDICIONAL >>> */}
                     {item.hasPendingSiblings && item.status === 'Pending' && item.isReadyToShip && ( // Mostra SÓ se o item está "Ready" mas tem irmãos pendentes
                         <span title="Este pedido tem outros itens ainda pendentes"> {/* Tooltip */}
                             <ClockIcon className="h-4 w-4 text-orange-500" /> {/* Ícone de Alerta/Pendente */}
                         </span>
                     )}
                     {/* <<< FIM DO INDICADOR >>> */}
                 </td>
                                    <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500">{item.orderDate && item.orderDate !== 'Data Inválida' ? item.orderDate : '-'}</td>
                                    <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500">{item.variantImageUrl ? <img src={`${BACKEND_URL}${item.variantImageUrl}`} alt={item.variantTitle || ''} className="h-10 w-10 object-cover rounded"/> : <div className="h-10 w-10 bg-gray-200 rounded flex items-center justify-center text-xs text-gray-400"><PhotoIcon className='h-5 w-5'/></div> }</td>
                                    <td className="px-4 py-4 text-sm text-gray-900 max-w-xs truncate" title={item.variantTitle || 'N/A'}>{item.variantTitle || 'N/A'}</td>
                                   <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500">{item.productCost ? `$${parseFloat(item.productCost).toFixed(2)}` : '-'}</td>
                                   {/* OnHold */}
                                    <td className="px-4 py-4 whitespace-nowrap text-center text-sm">
                                        <input
                                            type="checkbox"
                                            // Usa o valor de isOnHold vindo da API (|| false por segurança)
                                            checked={item.isOnHold || false}
                                            // Chama a MESMA função handleUpdateItem, passando o nome do campo e o novo valor
                                            onChange={(e) => handleUpdateItem(item.lineItemId, 'isOnHold', e.target.checked)}
                                            // Adicione um title para dica
                                            title={item.isOnHold ? "Desmarcar 'Em Espera'" : "Marcar como 'Em Espera'"}
                                            className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded cursor-pointer"
                                            // Poderíamos adicionar 'disabled' aqui se tivéssemos um estado de loading por item
                                        />
                                    </td>
                                    {/* --- TD RASTREIO (MODIFICADO) --- */}
                                    <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-600">
                                            {/* Apenas exibe o valor, sem input */}
                                            {item.trackingNumber || '-'}
                                        </td>
                                    {/* --- TD LOGÍSTICA --- */}
                                    <td className="px-4 py-4 whitespace-nowrap text-sm">
                                        <select
                                            value={item.shippingProvider || ''}
                                            onChange={(e) => handleUpdateItem(item.lineItemId, 'shippingProvider', e.target.value || null)}
                                            className="text-xs px-2 py-1 border border-gray-300 rounded focus:ring-indigo-500 focus:border-indigo-500"
                                        >
                                            <option value="">Não definido</option>
                                            <option value="4star">4star</option>
                                            <option value="sihi">Sihi</option>
                                            <option value="national_shipping">Nacional</option>
                                        </select>
                                    </td>
                                    <td className="px-4 py-4 whitespace-nowrap text-sm"><span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${ item.status === 'Pending' ? 'bg-yellow-100 text-yellow-800' : item.status === 'Shipped' ? 'bg-green-100 text-green-800' : item.status === 'National Shipping' ? 'bg-purple-100 text-purple-800' : 'bg-gray-100 text-gray-800' }`}>{item.status}</span></td>
                                    <td className="px-4 py-4 whitespace-nowrap text-center text-sm"><input type="checkbox" checked={item.isNationalShippingSelected} onChange={(e) => handleUpdateItem(item.lineItemId, 'isNationalShippingSelected', e.target.checked)} className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"/></td>
                                 </tr>
                             ))}
                         </tbody>
                      </table>
                  )}
             </div>
             {/* Paginação */}
             <div className="mt-4 flex flex-wrap justify-between items-center px-4 py-3 bg-white border-t border-gray-200 sm:px-6 rounded-b shadow-md gap-2">
                 <div className="text-sm text-gray-700"> Mostrando {isLoading? 0 : orderItems.length > 0 ? (currentPage - 1) * limit + 1 : 0} - {isLoading? 0 : Math.min(currentPage * limit, totalItems)} de {totalItems} itens </div>
                 <div className="flex items-center gap-1"> <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage <= 1 || isLoading || isSyncing} className="...">Anterior</button> <span className="mx-2 text-sm text-gray-700">Página {currentPage} de {totalPages}</span> <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage >= totalPages || isLoading || isSyncing} className="...">Próxima</button> </div>
             </div>
        </div>
    );
};

export default DashboardPage;